<player-sheet #sheet (hidden)="hideSheet()">
  <div class="z-funnel-container z-fx-col z-fx-center-stretch">
    @if (ss.showFunnelTwo | async) {
      <zef-funnel-two [answers]="ss.answers | async" (submit)="submitFunnelTwo($event)"></zef-funnel-two>
    }
  </div>
</player-sheet>
